<ul>
  <li><strong>property_type: </strong>{{ translationPrefix() + 'property_type' | translate }}</li>
  <li><strong>land_type: </strong>{{ translationPrefix() + 'land_type' | translate }}</li>
  <li><strong>zip_code: </strong>{{ translationPrefix() + 'zip_code' | translate }}</li>
  <li><strong>municipality_name: </strong>{{ translationPrefix() + 'municipality_name' | translate }}</li>
  <li><strong>street_name: </strong>{{ translationPrefix() + 'street_name' | translate }}</li>
  <li><strong>house_number: </strong>{{ translationPrefix() + 'house_number' | translate }}</li>
  <li><strong>area: </strong>{{ translationPrefix() + 'area' | translate }}</li>
  <li><strong>rating: </strong>{{ translationPrefix() + 'rating' | translate }}</li>
  <li><strong>name: </strong>{{ translationPrefix() + 'name' | translate }}</li>
  <li><strong>purchase_date: </strong>{{ translationPrefix() + 'purchase_date' | translate }}</li>
  <li><strong>purchase_price: </strong>{{ translationPrefix() + 'purchase_price' | translate }}</li>
  <li><strong>purchase_currency: </strong>{{ translationPrefix() + 'purchase_currency' | translate }}</li>
</ul>
